import { useIntl } from "react-intl";
import RpisPage from "../RpisPage/RpisPage";
import { ExportStatisticsContainer } from "./components/ExportStatisticsContainer/ExportStatisticsContainer";
import { useFetchDispAddresses } from "../../hooks/useFetchDispAddresses";
import { buildDispAddressesPayload } from "../DispManageAddresses/DispManageAddresses";
import { searchParamsInit } from "../../models/searchParams";
import { AddressType } from "../../models/address";
import { useMemo } from "react";
import Messages from "../../localization/Messages";
import { useSelector } from "react-redux";
import { useCachedDocks } from "../../hooks/useCachedDocks";
import { AppState } from "../../store/configureStore";
import "./ExportStatistics.css";

export const ExportStatistics = () => {
    const intl = useIntl();
    const { data: addressData } = useFetchDispAddresses(
        buildDispAddressesPayload({
            ...searchParamsInit,
            addressType: AddressType.OwningCompany,
            order: ["company asc"],
            addressSource: undefined,
            status: undefined,
            rowsPerPage: 0,
            page: 0,
        }),
    );
    const owningCompanies = useMemo(() => addressData?.addresses ?? [], [addressData]);
    const managingCompanies = useSelector((s: AppState) => s.managingCompanies).data;
    const { docks } = useCachedDocks();

    return (
        <RpisPage
            className="export-statistics-page"
            title={intl.formatMessage(Messages.exportStatistics)}
        >
            <ExportStatisticsContainer
                docks={docks}
                owningCompanies={owningCompanies}
                managingCompanies={managingCompanies}
            />
        </RpisPage>
    );
};

export default ExportStatistics;
